import React from 'react';
import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../redux/store';
import { setSelectedCategory } from '../redux/slices/selectedCategorySlice';
import { calcCostSum } from '../utils/calcCostSum';
import { useServiceQuery } from '../hooks/useServiceQuery';
import { getUniqueCategories } from '../utils/getUniqueCategoruies';
import styles from './styles/info.module.scss';

export const Info: React.FC = () => {
  // i18n
  const { t } = useTranslation();

  const selectedCategory = useAppSelector(
    (state) => state.selectedCategory.selectedCategory
  );
  const hasCookies = useAppSelector((state) => state.auth.hasCookies);
  const dispatch = useAppDispatch();

  // server states
  const { data, isLoading } = useServiceQuery(hasCookies);

  const uniqueCategories =
    isLoading || !hasCookies
      ? ['All Services']
      : getUniqueCategories(data!, true);

  const calculatedCostSum =
    isLoading || !hasCookies
      ? 0
      : calcCostSum(
          data!.filter(
            (service) =>
              service.category === selectedCategory ||
              selectedCategory === 'All Services'
          )
        );

  return (
    <div className={styles.container}>
      {/* dropdwon menu */}
      <div className={styles.left}>
        <Menu>
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon className={styles.downicon} />}
            className={styles.dropdownBtn}
          >
            {selectedCategory === 'All Services' ? t('all') : selectedCategory}
          </MenuButton>
          <MenuList>
            {uniqueCategories.map((category, index) => (
              <MenuItem
                minH="48px"
                key={index}
                className={styles.menuItem}
                onClick={() => dispatch(setSelectedCategory(category))}
              >
                <span>{category === 'All Services' ? t('all') : category}</span>
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </div>

      {/* monthly cost */}
      <div className={styles.right}>
        <div className={styles.money}>
          $ {calculatedCostSum} /{t('mo')}
        </div>
      </div>
    </div>
  );
};
